
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fyrirtaeki/umhverfisstefna",
      function () {
        return require("private-next-pages/fyrirtaeki/umhverfisstefna.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fyrirtaeki/umhverfisstefna"])
      });
    }
  